var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokIcon = function SvgTiktokIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 7.38A7.385 7.385 0 0 1 12.559 6v6.283a5.714 5.714 0 1 1-4.93-5.663v3.16a2.623 2.623 0 1 0 1.836 2.503V0h3.094c-.002.261.02.522.065.78A4.295 4.295 0 0 0 14.52 3.6a4.27 4.27 0 0 0 2.355.708V7.38Z",
    fill: "currentColor"
  })));
};
export default SvgTiktokIcon;